import { Button } from '@/components/design-system/Button';
import { useTranslation } from 'react-i18next';

export const NotificationsEmpty: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col">
      <div className="flex min-h-[200px] items-center justify-center px-4 py-8 text-center">
        <p className="text-sm text-white/60">{t('header.notifications.empty.title')}</p>
      </div>
      <div className="p-3">
        <Button variant="primary" size="fullWidth">
          {t('header.notifications.dashboard')}
        </Button>
      </div>
    </div>
  );
};
